/**
 * Single template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Single';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.info(`${NAME} > loaded`);
	initResizeIframes();
}

/**
 * initResizeIframes - Resize iframes
 */
const initResizeIframes = () => {
	Logger.info(`${NAME} > resizeFrames`);

	const singleContentDom = document.querySelector(`[data-single-content]`);
	const iframeDoms = singleContentDom?.querySelectorAll(`iframe`);

	const resizeIframe = (dom) => {
		Logger.info(`${NAME} > resizeIframe`);
		var width = dom.getAttribute("width");
		var height = dom.getAttribute("height");
		var actualWidth = dom.offsetWidth;
		dom.style.height = (actualWidth * (height / width)) + "px";
	}

	if (iframeDoms) {
		iframeDoms.forEach((iframeDom) => {
			resizeIframe(iframeDom);
			window.addEventListener("load", () => resizeIframe(iframeDom));
			window.addEventListener("resize", () => resizeIframe(iframeDom));
		});
	}
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
